import { useRef } from 'react'
import UploadFile from '@mui/icons-material/UploadFile'
import { Button } from '@mui/material'
import { useFileParser } from './useFileParser'

interface ParseProps {
  setProgressPercent: React.Dispatch<React.SetStateAction<number>>
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  setError: React.Dispatch<React.SetStateAction<string | null | undefined>>
}

const Upload = ({ setProgressPercent, setIsLoading, setError }: ParseProps) => {
  const { parseFile, acceptedExtensions } = useFileParser({
    setProgressPercent,
    setIsLoading,
    setError,
  })
  const inputFile = useRef<HTMLInputElement>(null)
  const handleFileUploadAsync = async (e: { target: HTMLInputElement }) => {
    const file = e.target.files?.[0]
    if (file) {
      await parseFile(file)
    }
  }

  const onButtonClick = () => {
    if (inputFile?.current != null) inputFile.current.click()
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <input
        id="upload-file"
        style={{ display: 'none' }}
        accept={acceptedExtensions.join().toLowerCase()}
        ref={inputFile}
        onChange={handleFileUploadAsync}
        type="file"
      />
      <Button
        variant="text"
        color="inherit"
        onClick={onButtonClick}
        startIcon={<UploadFile />}
      >
        Upload
      </Button>
    </div>
  )
}

export default Upload
